import React from 'react'
import {Component} from 'react'
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {getComapreProductDetail} from '../../actions/productCompare'

class Compare extends Component {

    componentDidMount(){
      
                
        
                
        
             var  myArray   = localStorage.getItem('myArray');
             const product_codes = JSON.parse(myArray)
        
                const options = {
                    connection_id : this.props.connection_id,
                    product_code : product_codes
                }
              
                this.props.getComapreProductDetail(options) 
        
    }
    removeCompare=(pc)=>{
        document.getElementById(pc).remove();
        var  myArray   = localStorage.getItem('myArray');

     const product_codes = JSON.parse(myArray)
    
     for( var i = 0; i < product_codes.length; i++){ 
     
         if ( product_codes[i] === pc) { 
     
             product_codes.splice(i, 1); 
         }
     
     }


localStorage.setItem('myArray', JSON.stringify(product_codes))


    }
    render(){
        const {compareDetail,product} = this.props
        
        return(
            
<div style={{width:'100%'}} className='mobile-compare-table'>
<table style={{width:'max-content'}}>
                                                                 
                                                                 <tbody style={{    textAlign: 'center'}}> 
                                                                 <tr>
                                                                 <td>
                                                                             &nbsp;
                                                                         </td>
                                                                         <td style={{padding:30}}>
                                                                             Title
                                                                         </td>
                                                                         <td style={{height:130}}>
                                                                         Image
                                                                         </td>
                                                                         
                                                                         <td style={{paddingTop:40}}>
                                                                             Brand
                                                                         </td>
                                                                         <td>Price
                                                                             
                                                                         </td><td>Details
  
                                                                         </td>
                                                                         <td>
                                                                             Option
                                                                         </td> 
                                                                         <td style={{padding:25}}>
                                                                             Product Code
                                                                         </td>
                                                                         <td>
                                                                         Description
                                                                             
                                                                          </td>
  
                                                                 </tr>
                                      {compareDetail.map((productCompare,index) =>{
                                  return(     <tr  role='row' id={productCompare.SKU_PRODUCT_CD} >
  <td onClick={()=>this.removeCompare(productCompare.SKU_PRODUCT_CD)} style={{cursor:'pointer'}}>Remove</td>
  
                                          
                                          
  
                                              <td style={{padding:30}}>{productCompare.SKU_DESC}</td>
                                              <td  >
                                          <img  style={{width:123}}
                                                  src={productCompare.SKU_IMAGE}
                                                  alt="" className="img-fluid" /> 
                                  
                                  </td>
                                  <td >{productCompare.SKU_BRD_DESC}</td>
                                  <td>{productCompare.MAX_PRICE}</td>
                                  <td>{productCompare.SKU_PRODUCT_DETAIL_DESC}</td>
  
                                 
                                      <td><Link to={`${process.env.PUBLIC_URL}/PD/${productCompare.QOL_LOT_CD}`} >
                                          <button className='btn btn-solid' style={{padding: 3,fontSize: 'small'}}>SELECT OPTIONS</button>
                                          </Link>
                                          </td> 
                                    <td>
                                        {productCompare.SKU_PRODUCT_CD}
                                    </td>
                                      <td style={{width:400}}>{productCompare.SKF_PRODUCT_GROUP_DESC}</td>
                                      </tr>
                                      
                                     
                                     )
                                  })
  
                              }
                               </tbody>
                                  
                                  </table> 
                              
  
</div>
        )
    }
}



const mapStateToProps = (state) => ({
    connection_id: state.tenant.connection_id,
    compareDetail : state.productCompare.compareDetail
})

const mapDispatchToProps = dispatch => bindActionCreators({
    getComapreProductDetail,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Compare);